import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Box, Paper, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { OTPInput } from '@components';
import { paths } from '@common/types';
import { postRequest } from '@config/axios/axios.config';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ResetPasswordContext } from './context';
import { formatApiError } from '@common/errors/error-formatting.ts';

export const MFAForm = () => {
  const [otpValue, setOTPValue] = useState<string>('');
  const [hasError, setHasError] = useState<boolean>(false);
  const { mfaToken, goToNextStep, mfaType, maskedPhoneNumber } =
    useContext(ResetPasswordContext);
  const navigate = useNavigate();

  if (!mfaToken) {
    navigate('/');
  }

  const handleOnChangeOtpValue = (newValue: string) => {
    setOTPValue(newValue);
    setHasError(false);
  };

  useEffect(() => {
    async function fetchMyAPI() {
      try {
        await postRequest<
          paths['/auth/password-reset/confirm']['post']['requestBody']['content']['application/json'],
          paths['/auth/password-reset/confirm']['post']['responses']['200']['content']['application/json']
        >('/auth/password-reset/confirm', {
          token: mfaToken,
          secret: otpValue,
        });

        goToNextStep();
      } catch (error) {
        toast.error(formatApiError(error));
      }
    }
    if (otpValue.length === 6 && !otpValue.includes(' ')) {
      fetchMyAPI();
    }
  }, [otpValue]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1.5rem',
        width: '28rem',
        height: '100%',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '1.5rem',
          //   paddingBlock: '3rem',
          gap: '16px',
          width: '100%',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            padding: 0,
          }}
        >
          <VerifiedUserIcon sx={{ fontSize: '3rem' }} color='primary' />
          <Typography
            sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
          >
            Verify your account
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 'regular',
              paddingY: '16px',
              textAlign: 'center',
            }}
          >
            {mfaType === 'sms'
              ? `Enter your 6-digit Bridge verification code sent to ${maskedPhoneNumber}.`
              : 'Open your authentication app, and enter the one-time password shown to verify your account.'}
          </Typography>
        </Box>

        <OTPInput
          value={otpValue}
          onChange={handleOnChangeOtpValue}
          length={6}
          hasError={hasError}
          errorMessage='Please enter a valid verification code.'
        />

        <Typography
          sx={{
            fontSize: '0.75rem',
            color: theme => theme.palette.semiBlack.main,
            textAlign: 'center',
            width: '100%',
            paddingTop: '1rem',
          }}
        >
          If you're unable to authenticate your account, please contact your
          system administrator.
        </Typography>
      </Paper>
    </Box>
  );
};
